/**
 * Trigger a browser download of an already-created object URL.
 * The caller keeps ownership of the URL and is responsible for revoking it.
 */
export function downloadObjectUrl(url: string, filename: string): void {
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  link.style.display = 'none';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}
